import Vue from 'vue'
import App from './App.vue'
import router from './router/index'// 导入路由
import request from './utils/request'// 导入axios请求


import './plugins/element' // 引入 Element 组件库

Vue.config.devtools = true // 确保开启 Devtools
// 挂载到原型
Vue.prototype.$request = request

// 如果是npm安装，需要设置Cesium基础路径
window.CESIUM_BASE_URL = '/'

Vue.config.productionTip = false

// console.log('当前模式:', process.env.VUE_APP_MODE)
// console.log('API基础URL:', process.env.VUE_APP_API_BASE_URL)

new Vue({
  router, // 注入路由
  render: h => h(App),
}).$mount('#app')
